import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";
import QRCode from "qrcode";

export default function PaymentPage() {
  const { txnid } = useParams();
  const navigate = useNavigate();

  const [tab, setTab] = useState("placeholder");
  const [seconds, setSeconds] = useState(300);
  const [txnData, setTxnData] = useState(null);
  const [qrImage, setQrImage] = useState("");

  const timerRef = useRef(null);
  const pollRef = useRef(null);
  const intentTriggeredRef = useRef(false);
  const [isChecking, setIsChecking] = useState(true);

  // ---------------- Fetch Transaction ----------------
  useEffect(() => {
    if (!txnid) return;

    const fetchTxn = async () => {
      try {
        const res = await authFetch(`/api/v1/report/get_txn3/${txnid}`);
        const data = await res.json();

        if (data.status === "success") {
          setTxnData(data);
        }
      } catch (err) {
        console.error("API Error:", err);
      }
    };

    fetchTxn();
  }, [txnid]);

  useEffect(() => {
  async function preCheck() {
    try {
      const res = await fetch(`/api/v1/report/get_txn_check/${txnid}`);
      const result = await res.json();
      const status = result?.data?.order_status;

      // if (!status) return;
      if (!status) {
        setIsChecking(false);
        return;
      }


      // if (status === "success") {
      //   window.location.href = result.data.success;
      //   return;
      // }

      // if (status === "failed") {
      //   window.location.href = result.data.failed;
      //   return;
      // }

      if (status === "success" || status === "failed") {
        // 2 sec blur show karo
        setTimeout(() => {
          window.location.href =
            status === "success"
              ? result.data.success
              : result.data.failed;
        }, 2000);

        return;
      }


      setIsChecking(false);

    } catch (err) {
      console.error("PRECHECK ERROR", err);
    }
  }

  preCheck();
}, [txnid]);

  // ---------------- Generate QR + Auto Intent ----------------
  useEffect(() => {
    // if (!txnData) return;
    if (!txnData || isChecking) return;

    const upiQR = txnData.deeplink;
    const upiIntent = txnData.deeplink;

    // Generate QR
    if (upiQR) {
      QRCode.toDataURL(upiQR)
        .then(setQrImage)
        .catch(console.error);
    }

    // Auto-flow
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent
    );

    // if (isMobile && upiIntent) {
    //   window.location.href = upiIntent;
    //   setTimeout(() => setTab("intent"), 1500);
    // } else {
    //   setTab("qr");
    // }

    if (isMobile && !intentTriggeredRef.current && upiIntent) {
      intentTriggeredRef.current = true;

      // UI first
      setTab("intent");

      // then redirect
      setTimeout(() => {
        window.location.href = upiIntent;
      }, 800);

    } else {
      // ✅ Web → QR
      setTab("qr");
    }


  // }, [txnData]);
  }, [txnData, isChecking]);

  // ---------------- Timer ----------------
  useEffect(() => {
    clearInterval(timerRef.current);

    if (tab === "placeholder") {
      setSeconds(300);
      return;
    }

    timerRef.current = setInterval(() => {
      setSeconds((s) => (s <= 1 ? 0 : s - 1));
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [tab]);

  // ---------------- Poll Status ----------------
  useEffect(() => {
    if (!txnid) return;

    clearInterval(pollRef.current);

    pollRef.current = setInterval(async () => {
      try {
        const res = await authFetch(`/api/v1/report/get_txn_check/${txnid}`);
        const data = await res.json();
        const status = data?.data?.order_status?.toLowerCase();

        if (status === "success") {
          clearInterval(pollRef.current);
          navigate("/success");
        }
        if (status === "failed") {
          clearInterval(pollRef.current);
          navigate("/failed");
        }
      } catch (err) {
        console.error("Polling error:", err);
      }
    }, 5000);

    return () => clearInterval(pollRef.current);
  }, [txnid, navigate]);

  // ---------------- Helpers ----------------
  const fmt = (s) =>
    `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(
      2,
      "0"
    )}`;

  const TabBtn = ({ id, icon, label }) => (
    <button
      className={`tab-btn ${tab === id ? "active" : ""}`}
      onClick={() => setTab(id)}
      disabled={tab === "placeholder"}
    >
      <i className={`bi ${icon}`}></i> {label}
    </button>
  );

  const amount = txnData?.amount || 0;

  return (
    <div className="bg-lock-screen">
      <div className="authentication-lock-screen d-flex align-items-center justify-content-center">
        <div className="container py-4" style={{ maxWidth: 550 }}>

          <style>{`
            .tab-btn{width:100%;background:#fff;border:1px solid #ddd;padding:12px;text-align:left;border-radius:4px;margin-bottom:10px;transition:.3s}
            .tab-btn.active{border-color:#2874f0;background:#e3f0ff;color:#2874f0;font-weight:600}
            .tab-btn i{margin-right:8px;color:#2874f0}
          `}</style>

          <div className="card shadow">
            <div className="card-body">

              <h5 className="card-title mb-3 d-flex align-items-center gap-2">
                <i className="bi bi-arrow-left" /> Complete Payment
                <span className="badge bg-light text-dark ms-auto">
                  ₹{Number(amount).toFixed(2)}
                </span>
              </h5>

              <div className="row g-4">
                {/* Left Column */}
                <div className="col-md-4">
                  <TabBtn id="qr" icon="bi-qr-code" label="QR" />
                  <TabBtn id="intent" icon="bi-upc-scan" label="UPI INTENT" />
                </div>

                {/* Right Column */}
                <div className="col-md-8">
                  <div
                    className="text-center mb-3"
                    style={{
                      color: "#ff0000",
                      fontSize: 16,
                      visibility: tab === "placeholder" ? "hidden" : "visible",
                    }}
                  >
                    ⏳ Payment link expires in <span>{fmt(seconds)}</span>
                  </div>

                  {/* Placeholder */}
                  {(tab === "placeholder" || isChecking) && (
                    <div className="text-center border rounded p-4">
                      <img
                        src="https://pngimg.com/uploads/qr_code/qr_code_PNG34.png"
                        alt="blurQr"
                        style={{ maxWidth: 170, height: 170, filter: "blur(2.5px)" }}
                      />
                      <h6 className="mt-3">Please Select Payment Mode</h6>
                    </div>
                  )}

                  {/* QR TAB */}
                  {tab === "qr" && !isChecking && (
                    <div className="text-center">
                      <h5 className="mb-3">Scan & Pay using any UPI App</h5>

                      {qrImage ? (
                        <img
                          src={qrImage}
                          alt="QR"
                          style={{
                            maxWidth: 170,
                            border: "4px solid",
                            padding: 10,
                          }}
                        />
                      ) : (
                        <p>Loading QR...</p>
                      )}

                      <p className="text-muted mt-3 mb-1">
                        Scan this QR code to pay{" "}
                        <span className="text-danger">₹{Number(amount).toFixed(2)}</span>
                      </p>
                      <p>Please wait for the transaction to be confirmed.</p>
                    </div>
                  )}

                  {/* INTENT TAB */}
                  {tab === "intent" && !isChecking && (
                    <div className="text-center">
                      <h5 className="mb-3">Pay via UPI Intent</h5>

                      <a
                        href={txnData?.deeplink}
                        className="btn btn-danger m-1 px-3 radius-30"
                        rel="noreferrer"
                      >
                        Pay Now
                      </a>

                      <h6 className="mt-4">Trusted by:</h6>
                      <div className="d-flex justify-content-center flex-wrap gap-3 mt-2">
                        {["gpay", "phonepe", "paytm", "bhim"].map((k) => (
                          <img
                            key={k}
                            src={`/assets/${k}-48.png`}
                            alt={k}
                            style={{ width: 30, height: 30 }}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
